import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommissionStatusCodes, CommissionStatusType, } from '../../../types/commissions';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import CommissionConfirmation from '../../../CommissionEditPopup/CommissionConfirmation';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import LockIcon from '../../../Icons/24x24/Lock';
import UnlockIcon from '../../../Icons/24x24/Unlock';
import ActionBarItemWrapper from '../../_partials/ActionBarButton/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/ActionBarButton/ActionBarEditButton';
export var CommissionStatusButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var isActionBarButtonRefactorFlagEnabled = useFlag('actionbar_button_refactor');
    var t = useTranslation().t;
    var _b = useState(false), showConfirmationPopup = _b[0], setShowConfirmationPopup = _b[1];
    if (!deviation.commission ||
        deviation.commission.status === CommissionStatusCodes.STATUS_DELETED) {
        return null;
    }
    var isActive = deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE;
    return (React.createElement(React.Fragment, null,
        isActionBarButtonRefactorFlagEnabled ? (React.createElement(ActionBarItemWrapper, { tooltip: isActive
                ? t('actionbar.closeCommission')
                : t('actionbar.openCommission') },
            React.createElement(ActionBarEditButton, { onClick: function () { return setShowConfirmationPopup(true); } },
                React.createElement(ActionBarIcon, { icon: isActive ? UnlockIcon : LockIcon })))) : (React.createElement(ActionBarButton, { tooltip: isActive
                ? t('actionbar.closeCommission')
                : t('actionbar.openCommission'), onClick: function () { return setShowConfirmationPopup(true); }, isEditAction: true },
            React.createElement(ActionBarIcon, { icon: isActive ? UnlockIcon : LockIcon }))),
        showConfirmationPopup && (React.createElement(CommissionConfirmation, { isOpen: true, confirmationType: isActive ? 'disable' : 'enable', onCancel: function () { return setShowConfirmationPopup(false); }, onConfirm: function () {
                setShowConfirmationPopup(false);
                onClick({
                    deviation: deviation,
                    status: isActive
                        ? CommissionStatusType.DISABLED
                        : CommissionStatusType.ACTIVE,
                });
            } }))));
};
CommissionStatusButton.displayName = 'CommissionStatusButton';
export default CommissionStatusButton;
//# sourceMappingURL=CommissionStatusButton.js.map